type Priority = 'low' | 'medium' | 'high';
type MediaType = 'photo' | 'video';

const DEBUG = false;

export interface PreloadMediaOptions {
  priority?: Priority;
}

interface ItemOptions {
  priority: Priority;
  type: MediaType;
  url: string;
  index: number;
}

let lastIndex = 0;
const queue: { [index: string]: ItemOptions } = {};

const loaded: { [url: string]: any } = {};
const loading: { [url: string]: any } = {};

export function preloadMedia(
  url: string,
  type: MediaType,
  options: PreloadMediaOptions = {},
) {
  if (loaded[url] || queue[url]) {
    return;
  }

  queue[url] = {
    priority: options.priority || 'low',
    type,
    url,
    index: ++lastIndex,
  };
  refreshPreload();
}

export function cancelPreloadMedia(url: string) {
  delete queue[url];
  delete loading[url];
  refreshPreload();
  if (DEBUG) {
    console.log('cancel preload', url);
  }
}

function calcSortRate(item: ItemOptions): number {
  let index = item.index;
  if (item.priority === 'high') {
    index += 10000000;
  } else if (item.priority === 'medium') {
    index += 5000000;
  }

  return index;
}

function refreshPreload() {
  const queueFlat = Object.values(queue)
    .sort((a, b) => {
      return calcSortRate(a) > calcSortRate(b) ? 1 : -1;
    })
    .slice(0, 10);

  for (let item of queueFlat) {
    if (!loading[item.url]) {
      startLoadMedia(item);
      if (DEBUG) {
        console.log('start load', item.url);
      }
    }
  }
}

function startLoadMedia(item: ItemOptions) {
  let tag: HTMLImageElement | HTMLVideoElement;
  if (item.type === 'video') {
    tag = document.createElement('video');
    tag.preload = 'auto';
  } else {
    tag = document.createElement('img');
  }
  loading[item.url] = tag;

  tag.onload = () => {
    onMediaLoaded(item.url, tag);
    refreshPreload();
  };
  tag.onerror = () => {
    delete queue[item.url];
    delete loading[item.url];
    refreshPreload();
  };
  tag.src = item.url;
}

function onMediaLoaded(url: string, tag: HTMLImageElement | HTMLVideoElement) {
  loaded[url] = tag; // save loaded media is required or it will be removed
  delete queue[url];
  delete loading[url];
  if (DEBUG) {
    console.log('onMediaLoaded', url);
    console.log(
      'cache size:',
      Object.values(loaded).length,
      'queue size:',
      Object.values(queue).length,
    );
  }
}
